module.exports = __webpack_public_path__ + "img/shousuo-zuo.c5f6e79f.svg";